module.exports = __webpack_public_path__ + "img/logo_cm.3de1832d.png";